import {Table } from 'antd'
import React, { useEffect, useState } from 'react'
import Copy from '../../cpn/Copy';
import classes from './invoice.module.css';
import StateTag from '../../cpn/StateTag';
import InvoiceEdit from './InvoiceEdit';
import InvoiceCheck from './InvoiceCheck';
import ReportCheck from '../../document/report/ReportCheck';
function InvoiceListPendding(props) {
    const [list,setList] = useState([]);   
    useEffect(() => {
        if (props.invoiceList) {
            let arr = props.invoiceList.filter((item) => item.kpsq_state === '1'&& item.kpsq_uid === props.yh_id);           
            arr.sort((a, b) => new Date(b.kpsq_ctime) - new Date(a.kpsq_ctime));
             // Ensure each item has a unique key property
             arr = arr.map((item) => ({
                ...item,
                key: item.key || item.kpsq_id
            }));
            setList(arr);
        }
    }, [props.invoiceList, props.yh_id])
    
    const columns = [    
        {
            title: '开票客户',
            dataIndex: 'kpsq_kh_name',
            width: '12%',
            key: 'kpsq_kh_name',         
            render: (text, record) => {
                if(record.kpsq_state === '1'){
                    return <InvoiceEdit 
                                kpsq_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                kpsq_bzd_id={record.kpsq_bzd_id}
                                kpsq_price={record.kpsq_price}
                                kpsq_content={record.kpsq_content}
                                kpsq_kh_name={record.kpsq_kh_name}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                kpsq_state={record.kpsq_state}
                            />
                }else{
                    return <InvoiceCheck 
                                kpsq_id={record.key} 
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                                kpsq_bzd_id={record.kpsq_bzd_id}
                                kpsq_price={record.kpsq_price}
                                kpsq_content={record.kpsq_content}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                kpsq_state={record.kpsq_state}
                            />
                 }
            }
        },
        {
            title: '开票金额',
            dataIndex: 'kpsq_amount',
            width: '10%',
            key: 'kpsq_amount',   
            render: (text, record) => <span style={{color:'#FF6600'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '开票项目',
            dataIndex: 'kpsq_name',
            key:'kpsq_name',
            render:(text, record) => <Copy title={record.kpsq_name}/>
        },   
        {
            title: '团队名称',
            dataIndex: 'kpsq_bzd_name',
            key:'kpsq_bzd_name',
            render:(text, record) => <ReportCheck dsbzd_id={record.kpsq_bzd_id} dsbzd_name={record.kpsq_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
        },       
        {
            title: '状态',
            dataIndex: 'kpsq_state',
            width: '5%',
            key: 'kpsq_state',            
            render:(text) => <StateTag state={text} />
        },
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },
        
    ]
    return (
        <>                            
            {/* <Flex style={{ marginBottom: "10px" }} justify='space-between' align='center'>
                <Form 
                    name='income' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        console.log(values,'values');
                        setQuery(prev => ({
                            ...prev, 
                            kpsq_content: values.kpsq_content ? values.kpsq_content : '', 
                            kpsq_kh_id: values.kpsq_kh_id ? values.kpsq_kh_id : '',
                            kpsq_bzd_danhao: values.kpsq_bzd_danhao ? values.kpsq_bzd_danhao : '',
                        }))
                    }}
                    initialValues={{
                        kpsq_content:'',
                        kpsq_kh_id:'',
                        kpsq_bzd_danhao:'',
                    }}
                >
                    <Form.Item name='kpsq_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            style={{width:'150px'}}
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name='kpsq_bzd_danhao'>
                        <Input 
                            placeholder='团队编号' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item name='kpsq_content'>
                        <Input 
                            placeholder='备注关键字' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({
                                        kpsq_content:''
                                    })
                                }}
                            />                          
                        </Space>
                    </Form.Item>
                </Form>
            </Flex> */}
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.kpsq_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1}>
                                <span style={{color:'#FF6600'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无开票申请数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default InvoiceListPendding